/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_PreviewInputs */

const en_profile_preview = /** @type {(inputs: Profile_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const pt_br2_profile_preview = /** @type {(inputs: Profile_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Profile_PreviewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_preview = /** @type {((inputs?: Profile_PreviewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_PreviewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_preview(inputs)
	return pt_br2_profile_preview(inputs)
});